import CryptoJS from "crypto-js";

class TokenManager {
  private static key = "accessToken";
}

// Ejecutamos y exportamos el resultado
export const environment = {
  openBaas: process.env.NEXT_PUBLIC_OPENBAAS,
  accessToken: TokenManager.getAccessToken,
};
